module.exports = __webpack_public_path__ + "img/004赵仕江.4a9b5550.jpg";